import { makeStyles } from '@mui/styles';
const ARROW_GIRTH = 3;
const buttonWithArrowStyles = makeStyles(({ palette }) => ({
    root: {
        paddingLeft: 20,
        borderRadius: 30,
    },
    label: {},
    arrow: {
        '&::after': {
            content: "' '",
            position: 'absolute',
            display: 'block',
            borderStyle: 'solid',
            borderWidth: '3px 0 0 3px',
            borderColor: ({ disabled, color }) => `${!disabled
                ? palette[color || 'primary'].main
                : palette.text.disabled}`,
            width: ({ arrowSize }) => arrowSize,
            height: ({ arrowSize }) => arrowSize,
            top: '50%',
            left: '50%',
            transform: ({ arrowSize }) => `translate(-50%, -50%) translate(-${(arrowSize ?? 0) / 5}px, 0) rotate(135deg)`,
            transition: 'margin .2s',
            borderRadius: `${ARROW_GIRTH / 1.5}px`,
        },
    },
}), { name: 'Common_ButtonWithArrow' });
export default buttonWithArrowStyles;
//# sourceMappingURL=buttonWithArrow.styles.js.map